export const MILLIS_PER_CREDIT = 1000;
export const CREDITS_PATTERN = /^\d+(\.\d+)?$/;
export const toCredits = (millis: number): number => millis / MILLIS_PER_CREDIT;
export const toMillis = (credits: string): number => Math.round(Number(credits) * MILLIS_PER_CREDIT);
